import { useState } from 'react';
import BankService from './BankService';

function useManageBanks() {
    const [banks, setBanks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshBanks = async () => {
        setIsLoading(true);
        try {
            const response = await BankService.getBanks();
            setBanks(response.data);
            setError(null);
        } catch (err) {
            console.log(err)
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const addBank = async (websiteData) => {
        let result = true
        setIsLoading(true);
        try {
            await BankService.addBank(websiteData);
            refreshBanks();
        } catch (err) {
            console.log(err)
            result = false
            setError(err.response.data.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result
    };

    const deleteBank = async (websiteId) => {
        setIsLoading(true);
        try {
            await BankService.deleteBank(websiteId);
            refreshBanks();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const updateBank = async (bankData) => {
        let result = true;
        setIsLoading(true);
        try {
            await BankService.updateBank(bankData);
            refreshBanks();
        } catch (err) {
            console.log(err);
            result = false;
            setError(err.response.data.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    return {
        banks,
        isLoading,
        error,
        addBank,
        deleteBank,
        refreshBanks,
        updateBank
    };
}

export default useManageBanks;
